import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';

/**
 * Vehicle group DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_GROUP)
export class VehicleGroupListDto extends BaseDto {
  name!: string;
  description?: string | null;
  tags?: TagListDto[] | null;
}
